import { MutationTree } from 'vuex';
import { IAlertState } from '@signing-page/alert/store/alert.store';
import { IAlert } from '@/types/Alert';

export const mutationAddAlert = 'addAlert';
export const mutationRemoveAlert = 'removeAlert';

export const mutations: MutationTree<IAlertState> = {
  [mutationAddAlert](state: IAlertState, alert: IAlert) {
    state.queue = [...state.queue, alert];
  },
  [mutationRemoveAlert](state: IAlertState) {
    state.queue.shift();
  },
};
